import { inject } from '@angular/core';
import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { ProjectStore } from '@ffx/app-store';

export function uniqueGroupNameValidator(): ValidatorFn {
    const projectStore = inject(ProjectStore);
    const selectedProject = projectStore.selectedProject;
    return (control: AbstractControl): ValidationErrors | null => {
        const allGroups = selectedProject().groups;
        if (allGroups) {
            const nameExists = allGroups.some((group) => group.name === control.value && !group.editing);
            return nameExists ? { duplicateGroupName: control.value } : null;
        }
        return null;
    };
}
